module.exports = __webpack_public_path__ + "img/buildNoti.a44b51e6.svg";